module.exports = __webpack_public_path__ + "static/img/message.b8d7927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/message.png
// module id = rc6A
// module chunks = 1